import React from 'react'

import Happen from 'components/common/sections/Happen/Happen'
import HappenData from './HappenData.json'

import styles from './DomainHappen.module.scss'

const DomainHappen = () => {
  return (
    <Happen
      conatinerClassName={styles.container}
      titleClassName={styles.title}
      contentClassName={styles.content}
      data={HappenData}
      title={'Someone else owns it but you want it. Let’s make that happen.'}
    />
  )
}

export default DomainHappen
